import { LinearProgress, TableBody, TableCell, TableRow } from '@mui/material';

interface SearchTableBodyProps {
    numCols: number;
    rows: { value: React.ReactNode | string; isButton: boolean }[][];
    emptyListText: string;
    loading: boolean;
}

export const SearchTableBody = ({ numCols, rows, emptyListText, loading }: SearchTableBodyProps) => {
    return (
        <TableBody>
            {loading ? (
                <TableRow sx={{ width: '100%' }}>
                    <TableCell colSpan={numCols} sx={{ width: '100%' }}>
                        <LinearProgress />
                    </TableCell>
                </TableRow>
            ) : rows.length ? (
                rows.map((row, index) => (
                    <TableRow key={index}>
                        {row.map((item, rowIdx) => {
                            return item.isButton ? (
                                <TableCell
                                    key={`${index}-${rowIdx}`}
                                    style={{
                                        borderColor: 'rgba(224, 224, 224, 1)',
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}>
                                    {item.value}
                                </TableCell>
                            ) : (
                                <TableCell key={`${index}-${rowIdx}`} style={{ borderColor: 'rgba(224, 224, 224, 1)' }}>
                                    {item.value}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                ))
            ) : (
                <TableRow>
                    <TableCell>{emptyListText}</TableCell>
                </TableRow>
            )}
        </TableBody>
    );
};
